<template>
  <b-container>
    <b-row style="margin-top: 20px">
      <b-col>
        <ul style="margin-left: -30px">
          <div
            v-for="(pathNode, index) of path"
            :key="index"
            :style="{ 'padding-left': 20 * index + 'px' }"
          >
            <div v-if="pathNode.nomenclature" class="disclaimer">
              <li>
                <b>{{ pathNode.nomenclature }}</b> {{ pathNode.name }}
              </li>
            </div>
          </div>
          <div :style="{ 'padding-left': 20 * path.length - 1 + 'px' }">
            <li style="margin-top: 5px; font-weight: bold">
              <b>{{
                requirement.evaluation_administrator_node_nomenclature
              }}</b>
              {{ requirement.evaluation_administrator_node_requirementName }}
            </li>
          </div>
        </ul>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "TemplateRequerimentsPath",
  props: ["requirement"],
  computed: {
    path() {
      var path = [];
      var req = this.requirement;
      while (req.parent && req.parent != null) {
        path.push(req.parent);
        req = req.parent;
      }
      return path.reverse();
    },
  },
};
</script>

<style lang="sass" >
/* components/template/_template-requirements-path.vue */
</style>
